export function isDebugModeOn(): boolean {
    return (import.meta.env.VITE_DEBUG_MODE === "true" && 
            import.meta.env.MODE === "development") // In production mode, always returns false.
}

const manifestUrl = "/manifest.json"

export async function getManifest() {
    return await (await fetch(manifestUrl)).json()
}

// Sanitisation
// copied from https://raw.githubusercontent.com/hfour/sanitize-filename-ts/refs/heads/master/src/index.ts

const illegalRe = /[\/\?<>\\:\*\|":,]/g;
/* tslint:disable-next-line:no-control-regex */
const controlRe = /[\x00-\x1f\x80-\x9f]/g;
const reservedRe = /^\.+$/;
const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
const windowsTrailingRe = /[\. ]+$/;

function replace(input: string, replacement: string) {
  const sanitized = input
    .replace(illegalRe, replacement)
    .replace(controlRe, replacement)
    .replace(reservedRe, replacement)
    .replace(windowsReservedRe, replacement)
    .replace(windowsTrailingRe, replacement);
  return sanitized;
}

export function sanitize(input: string, options?: { replacement: string }) {
  const replacement = (options && options.replacement) || "";
  const output = replace(input, replacement);
  if (replacement === "") {
    return output;
  }
  return replace(output, "");
}

export function stringifyStyleSheet(stylesheet: CSSStyleSheet) {
  return Array.from(stylesheet.cssRules)
    .map(rule => rule.cssText.replace(/([\{;])\s/g, "$1\n\t").replace(/\t\}/, "\}") || "")
    .join("\n\n")
}